var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 10.0004V14.0004C1.75 16.8288 1.75 18.243 2.62868 19.1217C2.84602 19.339 3.09612 19.5026 3.39228 19.6257C3.38556 19.5812 3.37922 19.5366 3.37321 19.492C3.24986 18.5745 3.24992 17.4288 3.25 16.099L3.25 8.0003L3.25 7.90155V7.90155C3.24992 6.57182 3.24986 5.4261 3.37321 4.50861C3.37921 4.46399 3.38555 4.41944 3.39226 4.375C3.09611 4.49812 2.84601 4.6617 2.62868 4.87903C1.75 5.75771 1.75 7.17192 1.75 10.0004Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 10.0004V14.0004C21.75 16.8288 21.75 18.243 20.8713 19.1217C20.654 19.339 20.4039 19.5026 20.1077 19.6257C20.1144 19.5812 20.1208 19.5366 20.1268 19.492C20.2501 18.5745 20.2501 17.4288 20.25 16.099V7.90156C20.2501 6.57183 20.2501 5.4261 20.1268 4.50861C20.1208 4.46399 20.1144 4.41944 20.1077 4.375C20.4039 4.49812 20.654 4.6617 20.8713 4.87903C21.75 5.75771 21.75 7.17192 21.75 10.0004Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62868 2.87868C4.75 3.75736 4.75 5.17157 4.75 8V16C4.75 18.8284 4.75 20.2426 5.62868 21.1213C6.50736 22 7.92157 22 10.75 22H12.75C15.5784 22 16.9926 22 17.8713 21.1213C18.75 20.2426 18.75 18.8284 18.75 16V8C18.75 5.17157 18.75 3.75736 17.8713 2.87868C16.9926 2 15.5784 2 12.75 2H10.75C7.92157 2 6.50736 2 5.62868 2.87868ZM8 17C8 16.5858 8.33579 16.25 8.75 16.25H11.75C12.1642 16.25 12.5 16.5858 12.5 17C12.5 17.4142 12.1642 17.75 11.75 17.75H8.75C8.33579 17.75 8 17.4142 8 17ZM8.75 12.25C8.33579 12.25 8 12.5858 8 13C8 13.4142 8.33579 13.75 8.75 13.75H14.75C15.1642 13.75 15.5 13.4142 15.5 13C15.5 12.5858 15.1642 12.25 14.75 12.25H8.75ZM8 9C8 8.58579 8.33579 8.25 8.75 8.25H14.75C15.1642 8.25 15.5 8.58579 15.5 9C15.5 9.41421 15.1642 9.75 14.75 9.75H8.75C8.33579 9.75 8 9.41421 8 9Z",
    fill: "#344767"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.ecd9f035991b4275b1216d3bdb95aecf.svg";
export { ForwardRef as ReactComponent };